import { ref, computed, onBeforeUnmount } from 'vue';
import type { Router } from 'vue-router';

export function useHideBackButtonFromRoutes(router: Router, excludedFromPaths: string[]) {
  const previousPath = ref<string | null>(null);

  const removeAfterEach = router.afterEach((_to, from) => {
    previousPath.value = from?.path ?? null;
  });

  const hideBackButton = computed(() => {
    if (!previousPath.value) return false;
    return excludedFromPaths.includes(previousPath.value);
  });

  onBeforeUnmount(() => {
    removeAfterEach();
  });

  return {
    previousPath,
    hideBackButton,
  };
}
